import React from "react";

const Signout = () => {
  return (
    <div>
      Sign out...
    </div>
  )
}

// localStorage.clear();

export default Signout;